import React from "react";
import { FaGlobe } from "react-icons/fa";
import { MdFormatListBulleted, MdDirectionsCar, MdFlight } from "react-icons/md";
import CrmListPage from "components/app/crm/shared/CrmListPage";
import { columnDefs as allColumns } from "./site/component/AllColumns";
import { columnDefs as carColumns } from "./site/component/CarBookingColumns";
import { columnDefs as travelColumns } from "./site/component/TravelBookingColumns";
import { getAllSites, getCarBookingSites, getTravelBookingSites, exportSites } from "redux/organization/siteSlice";

const noSort = (cols) => cols.map((c) => ({ ...c, sortable: false }));

const ADVANCED_FIELDS = [
  { key: "name",           label: "Name",           type: "text",     paramKey: "name_cont",           tagName: "Name" },
  { key: "active",         label: "Active only",    type: "checkbox", paramKey: "active_true",         tagName: "Active" },
  { key: "car_booking",    label: "Car booking",    type: "checkbox", paramKey: "car_booking_true",    tagName: "Car" },
  { key: "travel_booking", label: "Travel booking", type: "checkbox", paramKey: "travel_booking_true", tagName: "Travel" }
];

const TABS = [
  { key: "all",    label: "All",            Icon: MdFormatListBulleted, thunk: getAllSites,           dataKey: "allData",          columns: noSort(allColumns) },
  { key: "car",    label: "Car booking",    Icon: MdDirectionsCar,      thunk: getCarBookingSites,    dataKey: "carBookingData",   columns: noSort(carColumns) },
  { key: "travel", label: "Travel booking", Icon: MdFlight,             thunk: getTravelBookingSites, dataKey: "travelBookingData", columns: noSort(travelColumns) }
];

const SiteListPage = () => (
  <CrmListPage
    title="Sites"
    subtitle="Company sites and their booking capabilities."
    Icon={FaGlobe}
    reducerSelector={(s) => s.organization_site}
    tabs={TABS}
    columns={noSort(allColumns)}
    searchParamKey="id_or_name_cont"
    searchPlaceholder="ID#, site name..."
    advancedFields={ADVANCED_FIELDS}
    advancedTitle="Filters for sites"
    exportThunk={exportSites}
  />
);

export default SiteListPage;
